import { defineMessages } from 'react-intl'

export const downloadButtonCellMessages = defineMessages({
  title: {
    id: 'downloadButtonCell.title',
    description: 'Title/tooltip for "Download" button in table',
    defaultMessage: 'Download',
  },
})
